export const QUALITY_MODAL_CONFIGS = {
  assets: {
    titleKey: "collect:qualities.assets.title",
    sections: [
      {
        id: "post_treatment",
        titleKey: "collect:qualities.assets.analytics.title",
        component: "PostTreatmentResultOrganism",
      },
      {
        id: "equipment_distribution",
        titleKey:
          "collect:qualities.assets.doughnut_charts.equipment_type.title",
        component: "EquipmentDetailOrganism",
      },
      {
        id: "equipment_matching",
        titleKey:
          "collect:qualities.assets.stacked_charts.equipment_type.title",
        component: "MatchingBreakdownBarStackedChartAtom",
        props: { chartData: "matching_breakdown" },
      },
    ],
  },
  purchases: {
    titleKey: "collect:qualities.purchases.title",
    sections: [
      {
        id: "post_treatment_services",
        titleKey: "collect:qualities.purchases.analytics.title",
        component: "PostTreatmentResultOrganism",
      },
      {
        id: "services_per_purchase_provider",
        titleKey:
          "collect:qualities.purchases.services_per_purchase_provider.title",
        component: "EquipmentDetailOrganism",
        unitType: "money",
      },
      {
        id: "provider_matching",
        titleKey: "collect:qualities.purchases.provider_matching.title",
        component: "MatchingBreakdownBarStackedChartAtom",
        props: { chartData: "provider_matching_breakdown" },
      },
    ],
  },
  websites: {
    titleKey: "collect:qualities.websites.title",
    sections: [
      {
        id: "post_treatment_websites",
        titleKey: "collect:qualities.websites.analytics.title",
        component: "PostTreatmentResultOrganism",
      },
    ],
  },
  external_apps: {
    titleKey: "collect:qualities.external_apps.title",
    sections: [
      {
        id: "post_treatment_external_apps",
        titleKey: "collect:qualities.external_apps.analytics.title",
        component: "PostTreatmentResultOrganism",
      },
    ],
  },
  datacenter: {
    titleKey: "collect:qualities.datacenter.title",
    sections: [
      {
        id: "post_treatment_datacenter",
        titleKey: "collect:qualities.datacenter.analytics.title",
        component: "PostTreatmentResultOrganism",
      },
      {
        id: "datacenter_distribution",
        titleKey:
          "collect:qualities.datacenter.doughnut_charts.datacenters.title",
        component: "MultiDoughnutOrganism",
        props: {
          charts: [
            {
              dataKey: "datacenters_by_provider",
              kind: "raw",
              when: (fq) =>
                fq?.inventory_type === "data_center_external_inventories",
            },
            {
              dataKey: "datacenters_by_allocation",
              kind: "node",
            },
          ],
        },
      },
      {
        id: "assets_by_country",
        titleKey:
          "collect:qualities.datacenter.doughnut_charts.assets.by_country",
        component: "MultiDoughnutOrganism",
        props: {
          charts: [{ dataKey: "assets_by_country", kind: "raw" }],
        },
      },
      {
        id: "assets_by_datacenter",
        titleKey:
          "collect:qualities.datacenter.doughnut_charts.assets.by_datacenter",
        component: "MultiDoughnutOrganism",
        props: {
          charts: [{ dataKey: "assets_by_datacenter", kind: "raw" }],
        },
      },
      {
        id: "assets_by_equipment_type",
        titleKey:
          "collect:qualities.datacenter.doughnut_charts.assets.by_equipment_type",
        component: "MultiDoughnutOrganism",
        props: {
          charts: [{ dataKey: "equipment_types", kind: "equipment_type" }],
        },
      },
      {
        id: "equipment_matching",
        titleKey:
          "collect:qualities.datacenter.stacked_charts.equipment_type.title",
        component: "MatchingBreakdownBarStackedChartAtom",
        props: { chartData: "matching_breakdown" },
      },
    ],
  },
}
